import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "contact.png",
        title: "Contact Us",
        crumb: "Contact Us"
    }
}